import { DiscountService } from "../service/DiscountService";
import { DiscountServiceStrategyInterface } from "../service/DiscountServiceStrategyInterface";

export class DiscountSdkMethods {
    public constructor(private readonly discountService: DiscountService) {}

    public setCustomDiscountStrategy(
        strategy: DiscountServiceStrategyInterface
    ) {
        this.discountService.setStrategy(strategy);
    }
}
